import React from 'react';
import { useSelector } from 'react-redux';

import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';

export const FinalsLegend = () => {
    const nav = useSelector(navSelector);
    const filteredRounds = nav?.rounds?.filter(
        (round) =>
            round.abbreviation !== 'OR' &&
            round.abbreviation.slice(0, 2) !== 'Rd'
    );

    return (
        <div className="finals-legend">
            {filteredRounds?.map((round) => (
                <span key={round.id} className="finals-legend__item">
                    <span className="finals-legend__abbreviation">
                        {round.abbreviation + ': '}
                    </span>
                    <span className="finals-legend__name">{round.name}</span>
                </span>
            ))}
        </div>
    );
};
